// 直播间
const longSentencesShare = () => import('@/pages/share/longSentence.vue');
const wordShare = () => import('@/pages/share/word.vue');
const longSentencesCircleShare = () => import('@/pages/share/longSentencesCircle.vue');
export default [
  {
    path: '/longSentencesShare',
    name: 'longSentencesShare',
    component: longSentencesShare,
    meta: {
      title: '分享',
      requireAuth: true,
    },
  },
  {
    path: '/wordShare',
    name: 'wordShare',
    component: wordShare,
    meta: {
      title: '分享',
      requireAuth: true,
    },
  },
  {
    path: '/longSentencesCircleShare',
    name: 'longSentencesCircleShare',
    component: longSentencesCircleShare,
    meta: {
      title: '分享',
      requireAuth: true,
    },
  },
];
